import { render, staticRenderFns } from "./ScanKNF.vue?vue&type=template&id=4bdcabfa&scoped=true"
import script from "./ScanKNF.vue?vue&type=script&lang=js"
export * from "./ScanKNF.vue?vue&type=script&lang=js"
import style0 from "./ScanKNF.vue?vue&type=style&index=0&id=4bdcabfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcabfa",
  null
  
)

export default component.exports